export default [
  {
    path: "/caseList",
    component: () =>
      import(/* webpackChunkName: "case" */ "@/views/cases/list"),
    name: "caseList",
    meta: {
      isTab: true,
      keepAlive: false,
      links: ["案件管理"],
      permissionsPath: "/caseList"
    }
  },
  {
    path: "/caseDetail",
    component: () =>
      import(/* webpackChunkName: "case" */ "@/views/cases/detail"),
    name: "caseDetail",
    meta: {
      isTab: true,
      keepAlive: false,
      links: ["案件详情"],
      permissionsPath: ["/caseList", "/caseHandledList", "/casePendingList"]
    }
  },
  {
    path: "/caseAdd",
    component: () => import(/* webpackChunkName: "case" */ "@/views/cases/add"),
    name: "caseAdd",
    meta: {
      isTab: false,
      keepAlive: false,
      links: ["新增案件"],
      permissionsPath: "/caseList"
    }
  }
];
